"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { LocaleCode } from "@/lib/labels/types";
import type { ResolvedListings } from "@/features/tv-listings/utils/resolveMatchListings";
export interface UseTvListingsByDateReturn {
  /** matchNativeId → pre-resolved listings. Only matches with broadcasters appear. */
  tvByMatch: Record<string, ResolvedListings>;
  /** True while the fetch is in flight (initial or on param change). */
  loading: boolean;
}

/**
 * Fetches all broadcaster listings for a given day in the current tenant, in a single
 * call that runs in parallel with the matches fetch. Pre-resolved for the viewer locale,
 * so opening the TV modal is instant (no per-click lazy fetch).
 */
export function useTvListingsByDate(date, locale) {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [tvByMatch, setTvByMatch] = useState(t0);
  const [loading, setLoading] = useState(false);
  let t1;
  let t2;
  if ($[1] !== date || $[2] !== locale) {
    t1 = () => {
      if (!date) {
        setTvByMatch({});
        return;
      }
      let cancelled = false;
      setLoading(true);
      const qs = new URLSearchParams({
        date,
        locale
      });
      fetch(`/api/match-tv-listings/by-date?${qs.toString()}`).then(_temp).then(data => {
        if (cancelled) {
          return;
        }
        setTvByMatch(data || {});
      }).catch(() => {
        if (!cancelled) {
          setTvByMatch({});
        }
      }).finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t2 = [date, locale];
    $[1] = date;
    $[2] = locale;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== loading || $[6] !== tvByMatch) {
    t3 = {
      tvByMatch,
      loading
    };
    $[5] = loading;
    $[6] = tvByMatch;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(r) {
  return r.ok ? r.json() : {};
}